(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq-question').forEach(btn => {
  btn.addEventListener('click', function() {
    const item = this.closest('.faq-item');
    const answer = item.querySelector('.faq-answer');
    const expanded = this.getAttribute('aria-expanded') === 'true';
    
    // Close all other items (optional - remove this block if you want multiple open)
    document.querySelectorAll('.faq-item').forEach(i => {
      if (i !== item) {
        i.classList.remove('open');
        i.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        i.querySelector('.faq-answer').style.maxHeight = null;
      }
    });

    if (!expanded) {
      item.classList.add('open');
      this.setAttribute('aria-expanded', 'true');
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      item.classList.remove('open');
      this.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = null;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-showcase"] && !Shopify.designMode) return;
  try {
    
/* No JS required for static layout */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-points"] && !Shopify.designMode) return;
  try {
    
/* No custom JS required; relies on existing theme scripts (e.g., WOW.js) */

  } catch(e) { console.error(e); }
})();
})();
